import {defaultState} from './localstorage-manager';
import {reject} from 'lodash';
import helpers from '@app/helpers';

import Vue from 'vue';
const vm = new Vue();
const menuName = process.env.MENU_NAME;

export const mutations = {

	cacheLocation(state, {location}) {
		state.user.location = {latitude: location.latitude, longitude: location.longitude, timestamp: new Date()};
	},

	cacheVenue(state, {venue}) {
		state.venue = {...state.venue, ...venue};
	},

	cacheTimeslots(state, {timeslots}) {
		state.timeslots = timeslots;
	},

	cacheMenuList(state, {list}) {
		list.menus = list.menus.filter(menu => {
			return new RegExp(menuName, 'i').test(menu.name);
		});
		state.menuList = list;
	},

	cacheMenu(state, {id, menu}) {
		menu.createdAt = new Date();
		state.menus[id] = menu;
	},

	registrationError(state, {error}) {
		state.user.registerError = error;
	},

	clearRegistrationError(state) {
		state.user.registerError = null;
	},

	loginError(state, {error}) {
		state.user.loginError = error;
	},

	clearLoginError(state) {
		state.user.loginError = null;
	},

	cacheUser(state, {account}) {
		state.user.account = account;
	},

	logOut(state) {
		Object.keys(defaultState).forEach(key => {
			state[key] = defaultState[key];
		});
	},

	cacheBasketStatus(state, {status}) {
		state.basket.status = status;
	},

	cacheBraintreePaymentMethod(state, {type, nonce, deviceData}) {
		state.user.currentPaymentMethod = {type, nonce, deviceData, time: new Date()};
	},

	cacheOrder(state, {order}) {
		state.order = order;
	},

	resetOrder(state) {
		state.order = defaultState.order;
	},

	resetPaymentMethod(state) {
		state.user.currentPaymentMethod = {};
	},

	RESET_BASKET(state) {
		Object.keys(defaultState.basket).forEach(key => {
			state.basket[key] = defaultState.basket[key];
		});
	},

	SELECT_MENU(state, id) {
		state.menuId = id;
	},

	ADD_LINE_ITEM(state, lineItem) {
		state.basket.lines.push(lineItem);
	},

	INVALIDATE_ITEM(state, id) {

		for (let i = 0, len = state.basket.lines.length; i < len; i++) {
			const lineItem = state.basket.lines[i];

			if (lineItem.item.product.id === id) {
				lineItem.isInvalid = true;
				state.basket.invalidItems.push(id);
				break;
			}

			for (let choiceGroupKey in lineItem.choices) {
				const choiceGroup = lineItem.choices[choiceGroupKey];
				for (let choiceKey in choiceGroup) {
					const choice = choiceGroup[choiceKey];
					if (choice.productId === id) {
						choice.isInvalid = true;
						state.basket.invalidItems.push(id);
						break;
					}
				}
			}
		}
	},

	REMOVE_ITEM(state, id) {

		state.basket.lines = reject(state.basket.lines, (lineItem) => {
			return lineItem.basketItemId === id;
		});
	},

	SET_BREAKPOINT(state, name) {
		state.breakpoint = name;
	},

	UPDATE_ITEM(state, obj) {

		if (!obj.basketItemId) console.log('Cant update item without ID');

		state.basket.lines.forEach((item, index) => {
			if (item.basketItemId === obj.basketItemId) {
				const updated = Object.assign(item, obj);
				helpers.methods.updateLineItemPrice(updated);
				vm.$set(state.basket.lines, index, updated);
			}
		});
	},

	SELECT_TIMESLOT(state, obj) {
		state.basket.timeslot = obj.time;
		state.timeslot = obj;
	},

	ADD_LOCATIONS(state, array) {
		vm.$set(state.user.location, 'timestamp', new Date());
		vm.$set(state, 'locations', array);
		vm.$set(state, 'locationsLoaded', true);
	},

	UPDATE_LOCATIONS(state, array) {
		vm.$set(state, 'locations', array);
	},

	CLEAR_MENUS(state, array) {

		/* Clear Basket */
		for (const b in state.basket) {
			vm.$set(state.basket, b, []);
		}

		/* Clear Menus */
		vm.$set(state, 'menus', {});

		/* Clear selected venue */
		vm.$set(state, 'venue', {});
	},

	DETECT_IFRAME(state) {
		const iframe = (window.self !== window.top);
		state.iframe = iframe;
	},

	SET_BRAND(state, brand) {
		state.brand = brand;
	},
	SET_OFFLINE(state, status) {
		state.offline = status;
	},
	SET_LAST_ROUTE(state, path) {
		state.lastRoute = path;
	},
	SET_LOCATIONS_LOADED(state, bool) {
		state.locationsLoaded = bool;
	},
	SET_UI_COPY(state, uiCopy) {
		state.uiCopy = uiCopy;
	}
};



// WEBPACK FOOTER //
// ./src/vue/store/mutations.js